import React from 'react';
import { Box } from '@mui/material';

const Spinner: React.FC = () => {
    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100vh',
                    backgroundColor: '#fff',
                    zIndex: 9998
                }}
            />
            <Box
                sx={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    fontFamily: "'Times New Roman', serif",
                    fontSize: '24px',
                    color: '#000'
                }}
            >
                Loading
                <Box
                    component="span"
                    sx={{
                        display: 'inline-block',
                        width: '30px',
                        textAlign: 'left',
                        '@keyframes dots': {
                            '0%': { content: '"."' },
                            '33%': { content: '".."' },
                            '66%': { content: '"..."' },
                            '100%': { content: '"."' }
                        },
                        '&::after': {
                            content: '"."',
                            animation: 'dots 1.5s steps(3, end) infinite'
                        }
                    }}
                />
            </Box>
        </>
    );
};

export default Spinner;